import '../../shared-chunks/debug-to-string-BsFOvUtQ.js';
import '@embroider/macros';
import '../../@glimmer/global-context/index.js';
import '../../@glimmer/destroyable/index.js';
import '../../@glimmer/validator/index.js';
import '../../shared-chunks/reference-B6HMX4y0.js';
import '../../shared-chunks/capabilities-DHiXCCuB.js';
import { d as setModifierManager$1 } from '../../shared-chunks/api-1B_9SjFR.js';
export { m as capabilities } from '../../shared-chunks/api-1B_9SjFR.js';
export { on } from './on.js';
import '../../shared-chunks/index-CQkjwqTv.js';
import '../../shared-chunks/index-Cn-XMJI4.js';
import '../../shared-chunks/registry-XY5cfmbH.js';
import '../debug/index.js';
import '../../shared-chunks/dynamic-CIt6-yIX.js';
import '../../shared-chunks/constants-oDhF27qL.js';
import '../runloop/index.js';

// NOTE: this uses assignment to *require* that the `glimmerSetModifierManager`
// is legally assignable to this type, i.e. that variance is properly upheld.
const setModifierManager = setModifierManager$1;

export { setModifierManager };
